const rem = (...pixels) =>
  [...pixels].map((pixel) => `${pixel / 16}rem`).join(" ");

export default rem;
